exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#myChart {\r\n    width: 100%;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/thermometer/thermometer.component.css
// module id = ../../../../../src/app/content-page/thermometer/thermometer.component.css
// module chunks = main